import React, { useState, forwardRef, useImperativeHandle } from 'react';


const BankInfo = forwardRef((props, ref) => {
     // Add validation support
     const [validationErrors, setValidationErrors] = useState({});

     useImperativeHandle(ref, () => ({
          validateForm: () => {
               return true; // For now, always return true
          },
          clearValidation: () => {
               setValidationErrors({});
          }
     }));

     const [localFormData, localSetFormData] = useState({
          bank_account_name: '',
          bank_account_number: '',
          ifsc_code: '',
     });
     const formData = props.formData !== undefined ? props.formData : localFormData;
     const setFormData = props.setFormData !== undefined ? props.setFormData : localSetFormData;

     return (
          <div className="custom_form_wrapper">
               <div className="form-grid">
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control form-control-sm"
                              name="bank_account_name"
                              id="bank_account_name"
                              placeholder=" "
                              value={formData.bank_account_name}
                              onChange={e => setFormData({ ...formData, bank_account_name: e.target.value })}
                              autoComplete="off"
                         />
                         <label htmlFor="bank_account_name">Bank Account Name</label>
                    </div>
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control form-control-sm"
                              name="bank_account_number"
                              id="bank_account_number"
                              placeholder=" "
                              value={formData.bank_account_number}
                              onChange={e => setFormData({ ...formData, bank_account_number: e.target.value })}
                              autoComplete="off"
                         />
                         <label htmlFor="bank_account_number">Bank Account Number</label>
                    </div>
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control form-control-sm"
                              name="ifsc_code"
                              id="ifsc_code"
                              placeholder=" "
                              value={formData.ifsc_code}
                              onChange={e => setFormData({ ...formData, ifsc_code: e.target.value })}
                              autoComplete="off"
                         />
                         <label htmlFor="ifsc_code">IFSC Code</label>
                    </div>
               </div>
          </div>
     );
});

export default BankInfo;